export default function (quoteId, addons) {
  return {
    query: `mutation (
              $quoteId: String!,
              $addons: [Addon]
            ) {
              createPaymentTransaction(
                saleOrderAccessToken: $quoteId,
                addons: $addons
              ) {
                apiUrl
              }
            }`,
    variables: {
      quoteId,
      addons,
    },
  }
}
